(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-horizontal-scroll]:not([data-scroll-init])').forEach((track) => {
    track.setAttribute('data-scroll-init', 'true');

    track.addEventListener('keydown', (event) => {
      const scrollAmount = Math.max(track.clientWidth * 0.6, 200);

      if (event.key === 'ArrowRight') {
        track.scrollLeft += scrollAmount;
        event.preventDefault();
      }

      if (event.key === 'ArrowLeft') {
        track.scrollLeft -= scrollAmount;
        event.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-collection-page]');
    if (!page) return;

    const dialog = page.querySelector('[data-filter-dialog]');
    const openButton = page.querySelector('[data-filter-open]');
    const closeButton = page.querySelector('[data-filter-close]');
    const sortSelect = page.querySelector('[data-sort-select]');
    const sortForm = page.querySelector('[data-sort-form]');
    const filterForms = page.querySelectorAll('[data-filter-form]');

    if (openButton && dialog) {
      openButton.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    }

    if (closeButton && dialog) {
      closeButton.addEventListener('click', () => dialog.close());
    }

    if (sortSelect && sortForm) {
      sortSelect.addEventListener('change', () => sortForm.submit());
    }

    filterForms.forEach((form) => {
      const isMobileForm = form.classList.contains('collection-page__filters-form--mobile');

      if (!isMobileForm) {
        form.addEventListener('change', (event) => {
          if (event.target.matches('input[type="checkbox"]')) {
            form.requestSubmit();
          }
        });

        form.querySelectorAll('[data-price-filter-input]').forEach((input) => {
          input.addEventListener('change', () => {
            form.requestSubmit();
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-highlights"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-horizontal-scroll]:not([data-scroll-init])').forEach((track) => {
    track.setAttribute('data-scroll-init', 'true');

    track.addEventListener('keydown', (event) => {
      const scrollAmount = Math.max(track.clientWidth * 0.6, 200);

      if (event.key === 'ArrowRight') {
        track.scrollLeft += scrollAmount;
        event.preventDefault();
      }

      if (event.key === 'ArrowLeft') {
        track.scrollLeft -= scrollAmount;
        event.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const navItems = header.querySelectorAll('[data-nav-item]');
    const mobileNav = header.querySelector('[data-mobile-nav]');
    const mobileOpen = header.querySelector('[data-mobile-nav-open]');
    const mobileClose = header.querySelector('[data-mobile-nav-close]');
    const mobileBack = header.querySelector('[data-mobile-nav-back]');
    const mobileTitle = header.querySelector('[data-mobile-nav-title]');
    const mobilePanels = header.querySelector('[data-mobile-nav-panels]');
    const panelStack = [{ id: 'root', title: '' }];

    let hoverTimer;
    let closeTimer;

    const closeAllMegaMenus = () => {
      navItems.forEach((item) => {
        item.classList.remove('header-category-bar__item--open');
        item.classList.remove('header-nav__item--open');
        const trigger = item.querySelector('[data-nav-trigger]');
        const panel = item.querySelector('[data-mega-menu]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    };

    const openMegaMenu = (item) => {
      closeAllMegaMenus();
      item.classList.add('header-category-bar__item--open');
      item.classList.add('header-nav__item--open');
      const trigger = item.querySelector('[data-nav-trigger]');
      const panel = item.querySelector('[data-mega-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    };

    navItems.forEach((item) => {
      const trigger = item.querySelector('[data-nav-trigger]');
      const panel = item.querySelector('[data-mega-menu]');
      if (!trigger || !panel) return;

      item.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        hoverTimer = window.setTimeout(() => openMegaMenu(item), 80);
      });

      item.addEventListener('mouseleave', () => {
        window.clearTimeout(hoverTimer);
        closeTimer = window.setTimeout(closeAllMegaMenus, 160);
      });

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeAllMegaMenus();
        } else {
          openMegaMenu(item);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllMegaMenus();
    });

    const showMobilePanel = (panelId, title) => {
      if (!mobilePanels) return;
      mobilePanels.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.mobilePanel !== panelId;
      });
      if (mobileBack) mobileBack.hidden = panelId === 'root';
      if (mobileTitle && title) mobileTitle.textContent = title;
    };

    const openMobileNav = () => {
      if (!mobileNav) return;
      panelStack.length = 0;
      panelStack.push({ id: 'root', title: mobileTitle?.dataset.defaultTitle || '' });
      showMobilePanel('root', mobileTitle?.dataset.defaultTitle || mobileTitle?.textContent);
      if (typeof mobileNav.showModal === 'function') mobileNav.showModal();
      document.documentElement.classList.add('mobile-nav-open');
    };

    const closeMobileNav = () => {
      if (!mobileNav?.open) return;
      mobileNav.close();
      document.documentElement.classList.remove('mobile-nav-open');
      showMobilePanel('root');
    };

    if (mobileTitle) {
      mobileTitle.dataset.defaultTitle = mobileTitle.textContent;
    }

    mobileOpen?.addEventListener('click', openMobileNav);
    mobileClose?.addEventListener('click', closeMobileNav);

    mobileNav?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeMobileNav();
    });

    mobileNav?.querySelectorAll('[data-mobile-open-panel]').forEach((button) => {
      button.addEventListener('click', () => {
        const panelId = button.getAttribute('data-mobile-open-panel');
        const title = button.getAttribute('data-mobile-panel-title');
        if (!panelId) return;
        panelStack.push({ id: panelId, title: title || '' });
        showMobilePanel(panelId, title);
      });
    });

    mobileBack?.addEventListener('click', () => {
      if (panelStack.length <= 1) return;
      panelStack.pop();
      const current = panelStack[panelStack.length - 1];
      if (current.id === 'root') {
        showMobilePanel('root', mobileTitle?.dataset.defaultTitle);
      } else {
        showMobilePanel(current.id, current.title);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-horizontal-scroll]:not([data-scroll-init])').forEach((track) => {
    track.setAttribute('data-scroll-init', 'true');

    track.addEventListener('keydown', (event) => {
      const scrollAmount = Math.max(track.clientWidth * 0.6, 200);

      if (event.key === 'ArrowRight') {
        track.scrollLeft += scrollAmount;
        event.preventDefault();
      }

      if (event.key === 'ArrowLeft') {
        track.scrollLeft -= scrollAmount;
        event.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prelaunch-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-prelaunch-catalog]');
    if (!root) return;
    var raw = root.querySelector('[data-prelaunch-catalogue]');
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    var products = data.products || [];
    var detail = root.getAttribute('data-detail-url') || '/pages/forhaandsvisning-produkt';
    var labels = {
      opbevaring: 'Opbevaring', koekken: 'Køkken', badevaerelse: 'Badeværelse',
      belysning: 'Belysning', tekstiler: 'Tekstiler', boligtilbehoer: 'Boligtilbehør', all: 'Alle'
    };
    var params = new URLSearchParams(window.location.search);
    var activeCategory = params.get('category') || 'all';
    var activeSet = params.get('set') || '';
    var activeRoom = params.get('room') || '';

    function matches(p) {
      if (p.market === 'DROP_REVIEW' && activeSet !== 'all-including-drop') {
        /* still show in full catalogue, but deprioritize visually only when filtering merch sets */
      }
      if (activeSet === 'popular') return (p.merch || []).indexOf('merch:popular') >= 0 && p.market !== 'DROP_REVIEW';
      if (activeSet === 'selected') return (p.merch || []).indexOf('merch:selected') >= 0 && p.market !== 'DROP_REVIEW';
      if (activeSet === 'new') return (p.merch || []).indexOf('merch:new') >= 0 && p.market !== 'DROP_REVIEW';
      if (activeSet === 'hero') return (p.merch || []).indexOf('merch:hero') >= 0;
      if (activeCategory !== 'all' && p.primary_collection !== activeCategory) return false;
      if (activeRoom && (p.rooms || []).indexOf(activeRoom) < 0) return false;
      return true;
    }

    function card(p) {
      var cat = labels[p.primary_collection] || '';
      var merch = p.merch || [];
      var badge = '';
      if (merch.indexOf('merch:new') >= 0) badge = '<span class="prelaunch-card__badge">Nyhed</span>';
      else if (merch.indexOf('merch:popular') >= 0) badge = '<span class="prelaunch-card__badge">Populær</span>';
      var price = p.price ? String(p.price).replace(/\.00$/, '') + ' kr' : '';
      var img = p.primary_image
        ? '<img class="prelaunch-card__image" src="' + p.primary_image + '" alt="" loading="lazy">'
        : '<div class="prelaunch-card__placeholder"></div>';
      return '<article class="prelaunch-card"><a class="prelaunch-card__link" href="' + detail + '?handle=' + encodeURIComponent(p.handle) + '"><div class="prelaunch-card__media">' + img + badge + '</div><div class="prelaunch-card__body">' + (cat ? '<p class="prelaunch-card__category">' + cat + '</p>' : '') + '<h3 class="prelaunch-card__title">' + p.title + '</h3>' + (price ? '<p class="prelaunch-card__price">' + price + '</p>' : '') + '</div></a></article>';
    }

    var filters = root.querySelector('[data-pl-filters]');
    filters.innerHTML = Object.keys(labels).map(function (key) {
      var cls = (!activeSet && activeCategory === key) ? ' is-active' : '';
      var href = key === 'all' ? window.location.pathname : (window.location.pathname + '?category=' + key);
      return '<button type="button" class="' + cls.trim() + '" data-href="' + href + '">' + labels[key] + '</button>';
    }).join('');
    filters.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () { window.location.href = btn.getAttribute('data-href'); });
    });

    var list = products.filter(matches);
    root.querySelector('[data-pl-count]').textContent = list.length + ' produkter';
    root.querySelector('[data-pl-catalog-grid]').innerHTML = list.map(card).join('');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prelaunch-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-prelaunch-home]');
    if (!root) return;

    function run(data) {
      var products = data.products || [];
      var byHandle = {};
      var bySku = {};
      products.forEach(function (p) {
        byHandle[p.handle] = p;
        if (p.sku) bySku[p.sku] = p;
        (p.skus || []).forEach(function (s) { bySku[s] = p; });
      });

      var liveNode = root.querySelector('[data-pl-live-products]');
      var liveByHandle = {};
      if (liveNode && liveNode.textContent) {
        try { liveByHandle = JSON.parse(liveNode.textContent); } catch (e) { liveByHandle = {}; }
      }
      Object.keys(liveByHandle).forEach(function (handle) {
        var live = liveByHandle[handle] || {};
        var existing = byHandle[handle] || { handle: handle };
        if (live.price != null && live.price !== '') existing.price = String(live.price).replace(',', '.');
        if (live.title) existing.title = live.title;
        if (live.image) {
          existing.primary_image = live.image;
          existing.image = live.image;
        }
        existing.available = live.available !== false;
        byHandle[handle] = existing;
      });

      var home = data.homepage || {};
      var detail = root.getAttribute('data-detail-url') || '/products';
      var catalog = root.getAttribute('data-catalog-url') || '/collections/all';

      var labels = {
        opbevaring: 'Opbevaring',
        koekken: 'Køkken',
        badevaerelse: 'Badeværelse',
        belysning: 'Belysning',
        tekstiler: 'Tekstiler',
        boligtilbehoer: 'Boligtilbehør'
      };

      function esc(s) {
        return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      }

      function card(p) {
        if (!p) return '';
        if (p.available === false) return '';
        var cat = labels[p.primary_collection] || '';
        var badge = '';
        var merch = p.merch || [];
        if (merch.indexOf('merch:new') >= 0) badge = '<span class="prelaunch-card__badge">Nyhed</span>';
        else if (merch.indexOf('merch:popular') >= 0) badge = '<span class="prelaunch-card__badge">Populær</span>';
        var priceNum = p.price ? String(p.price).replace(',', '.').replace(/\.00$/, '') : '';
        var price = priceNum ? priceNum + ' kr' : '';
        var src = p.primary_image || p.image || '';
        var img = src
          ? '<img class="prelaunch-card__image" src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy" width="800" height="1000">'
          : '<div class="prelaunch-card__placeholder" aria-hidden="true"></div>';
        return (
          '<article class="prelaunch-card"><a class="prelaunch-card__link" href="' + detail.replace(/\/$/, '') + '/' + encodeURIComponent(p.handle) + '">' +
          '<div class="prelaunch-card__media">' + img + badge + '</div>' +
          '<div class="prelaunch-card__body">' +
          (cat ? '<p class="prelaunch-card__category">' + cat + '</p>' : '') +
          '<h3 class="prelaunch-card__title">' + esc(p.title) + '</h3>' +
          (price ? '<p class="prelaunch-card__price">' + price + '</p>' : '') +
          '</div></a></article>'
        );
      }

      function fill(sel, handles) {
        var el = root.querySelector('[data-pl-grid="' + sel + '"]');
        if (!el) return 0;
        if (el.hasAttribute('data-live-collection')) return el.querySelectorAll('.product-card').length;
        var html = (handles || []).map(function (h) { return card(byHandle[h]); }).join('');
        el.innerHTML = html;
        return el.querySelectorAll('.prelaunch-card').length;
      }

      fill('popular', home.popular_handles || []);
      fill('selected', home.selected_handles || []);
      fill('new', home.new_handles || []);

      function applyMediaHandle(el) {
        var handle = el.getAttribute('data-pl-media-handle');
        if (!handle) return false;
        var p = byHandle[handle];
        if (!p) return false;
        var src = p.primary_image || p.image || '';
        if (!src) return false;
        el.style.backgroundImage = 'url("' + src.replace(/"/g, '\\"') + '")';
        return true;
      }

      root.querySelectorAll('[data-pl-media-handle]').forEach(function (el) {
        applyMediaHandle(el);
      });

      var heroSku = (home.hero_skus || [])[0];
      var hero = bySku[heroSku] || byHandle['vasketoejskurv-med-3-rum-135-l'] || byHandle[(home.popular_handles || [])[0]];
      var heroMedia = root.querySelector('[data-pl-hero-media]');
      if (heroMedia && hero) {
        var heroSrc = hero.primary_image || hero.image;
        if (heroSrc) {
          heroMedia.style.backgroundImage = 'url("' + heroSrc.replace(/"/g, '\\"') + '")';
          var heroImg = heroMedia.querySelector('[data-pl-hero-img]');
          if (heroImg && !heroImg.getAttribute('src')) {
            heroImg.src = heroSrc;
            heroImg.alt = hero.title || heroImg.alt || '';
            heroImg.classList.add('is-ready');
          }
        }
      }
    }

    var catalogueUrl = root.getAttribute('data-catalogue-url');
    if (!catalogueUrl) {
      console.error('[EYLO home] missing catalogue URL');
      return;
    }

    fetch(catalogueUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('catalogue HTTP ' + res.status);
        return res.json();
      })
      .then(run)
      .catch(function (e) {
        console.error('[EYLO home] catalogue load failed', e);
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prelaunch-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-prelaunch-pdp]');
    if (!root) return;
    var data;
    try { data = JSON.parse(root.querySelector('[data-prelaunch-catalogue]').textContent); } catch (e) { return; }
    var handle = new URLSearchParams(window.location.search).get('handle');
    var product = (data.products || []).find(function (p) { return p.handle === handle; });
    var mount = root.querySelector('[data-pl-pdp]');
    var catalog = root.getAttribute('data-catalog-url') || '/pages/forhaandsvisning';
    if (!product) {
      mount.innerHTML = '<p>Produktet blev ikke fundet i forhåndsvisningen.</p><a class="prelaunch-pdp__back" href="' + catalog + '">Tilbage til katalog</a>';
      return;
    }
    var labels = {
      opbevaring: 'Opbevaring', koekken: 'Køkken', badevaerelse: 'Badeværelse',
      belysning: 'Belysning', tekstiler: 'Tekstiler', boligtilbehoer: 'Boligtilbehør'
    };
    var images = product.images || [];
    var main = product.primary_image || (images[0] && images[0].url) || '';
    var thumbs = images.slice(0, 4).map(function (img, i) {
      var url = img.url || img;
      return '<img src="' + url + '" alt="" data-full="' + url + '"' + (i === 0 ? ' class="is-active"' : '') + '>';
    }).join('');
    var price = product.price ? String(product.price).replace(/\.00$/, '') + ' kr' : '';
    var meta = '';
    if (product.sku) meta += '<li><span>SKU</span> ' + product.sku + '</li>';
    if (product.barcode) meta += '<li><span>EAN</span> ' + product.barcode + '</li>';
    if (product.material) meta += '<li><span>Materiale</span> ' + product.material + '</li>';
    if (product.dimensions) meta += '<li><span>Mål</span> ' + product.dimensions + '</li>';
    if (product.color) meta += '<li><span>Farve</span> ' + product.color + '</li>';
    if (product.weight && product.weight.value) meta += '<li><span>Vægt</span> ' + product.weight.value + ' ' + (product.weight.unit || '') + '</li>';
    if (product.primary_collection) meta += '<li><span>Kategori</span> ' + (labels[product.primary_collection] || product.primary_collection) + '</li>';

    mount.innerHTML =
      '<a class="prelaunch-pdp__back" href="' + catalog + '">← Tilbage til katalog</a>' +
      '<div class="prelaunch-pdp__grid">' +
      '<div class="prelaunch-pdp__gallery">' +
      (main ? '<img class="prelaunch-pdp__main-image" data-pl-main src="' + main + '" alt="' + (product.title || '') + '">' : '') +
      '<div class="prelaunch-pdp__thumbs">' + thumbs + '</div></div>' +
      '<div class="prelaunch-pdp__info">' +
      '<p class="prelaunch-pdp__eyebrow">EYLO</p>' +
      '<h1 class="prelaunch-pdp__title">' + product.title + '</h1>' +
      (price ? '<p class="prelaunch-pdp__price">' + price + '</p>' : '') +
      '<p class="prelaunch-pdp__note">Forhåndsvisning — ikke til salg endnu</p>' +
      '<ul class="prelaunch-pdp__meta">' + meta + '</ul>' +
      '<div class="prelaunch-pdp__desc">' + (product.description_html || product.description_text || '') + '</div>' +
      '</div></div>';

    mount.querySelectorAll('.prelaunch-pdp__thumbs img').forEach(function (img) {
      img.addEventListener('click', function () {
        var mainImg = mount.querySelector('[data-pl-main]');
        if (mainImg) mainImg.src = img.getAttribute('data-full');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const section = document.querySelector('.product-page');
    if (!section) return;

    const variantDataEl = section.querySelector('[data-variant-data]');
    const mediaRoot = section.querySelector('[data-product-media]');
    const form = section.querySelector('[data-product-form]');
    if (!variantDataEl || !form) return;

    /** @type {Array<{id:number,available:boolean,options:string[],price:number,compare_at_price:number|null,price_html:string,compare_at_price_html:string,featured_media_id:number|null}>} */
    const variants = JSON.parse(variantDataEl.textContent);
    const variantInput = form.querySelector('[data-variant-input]');
    const priceRoot = section.querySelector('[data-price-root]');
    const availabilityRoot = section.querySelector('[data-availability-root]');
    const submitButton = form.querySelector('[data-add-to-cart]');
    const optionButtons = form.querySelectorAll('[data-option-button]');
    const optionSelects = form.querySelectorAll('[data-option-select]');
    const quantityInput = form.querySelector('[data-quantity-input]');
    const decreaseButton = form.querySelector('[data-quantity-decrease]');
    const increaseButton = form.querySelector('[data-quantity-increase]');

    const stringsEl = section.querySelector('[data-product-strings]');
    const strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};

    function getSelectedOptions() {
      const optionCount = variants[0]?.options?.length || 0;
      const selected = [];

      for (let index = 0; index < optionCount; index += 1) {
        const select = form.querySelector(`[data-option-select][data-option-index="${index}"]`);
        if (select) {
          selected[index] = select.value;
          continue;
        }

        const activeButton = form.querySelector(
          `[data-option-button][data-option-index="${index}"].product-form__option-button--selected`
        );
        selected[index] = activeButton ? activeButton.dataset.optionValue : variants[0].options[index];
      }

      return selected;
    }

    function findVariant(options) {
      return variants.find((variant) =>
        variant.options.every((value, index) => value === options[index])
      );
    }

    function variantExists(options) {
      return variants.some((variant) =>
        variant.options.every((value, index) => value === options[index])
      );
    }

    function updateOptionStates() {
      const selected = getSelectedOptions();

      optionButtons.forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValue;
        const testOptions = [...selected];
        testOptions[optionIndex] = optionValue;
        const exists = variantExists(testOptions);
        const variant = findVariant(testOptions);
        const soldOut = exists && variant && !variant.available;

        // Keep sold-out options selectable so price/ATC can show "Udsolgt",
        // but disable truly missing combinations.
        button.disabled = !exists;
        button.classList.toggle('product-form__option-button--sold-out', !!soldOut);
        button.setAttribute('aria-disabled', !exists || soldOut ? 'true' : 'false');
        if (soldOut) {
          button.setAttribute('title', strings.soldOut || 'Udsolgt');
        } else if (!button.classList.contains('product-form__option-button--swatch')) {
          button.removeAttribute('title');
        }
      });
    }

    function updatePrice(variant) {
      if (!priceRoot) return;

      const currentEl = priceRoot.querySelector('[data-price-current]');
      const compareEl = priceRoot.querySelector('[data-price-compare]');

      if (currentEl) currentEl.textContent = variant.price_html;

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = variant.compare_at_price_html;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
    }

    function updateAvailability(variant) {
      if (!availabilityRoot) return;

      availabilityRoot.innerHTML = variant.available
        ? `<span class="product-buy-box__availability-text product-buy-box__availability-text--available">${strings.inStock}</span>`
        : `<span class="product-buy-box__availability-text product-buy-box__availability-text--sold-out">${strings.soldOut}</span>`;
    }

    function updateSubmit(variant) {
      if (!submitButton) return;

      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available ? strings.addToCart : strings.soldOut;

      const stickyTrigger = section.querySelector('[data-sticky-atc-trigger]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyTrigger) {
        stickyTrigger.disabled = !variant.available;
        stickyTrigger.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }
      if (stickyPrice) {
        stickyPrice.textContent = variant.price_html;
      }
    }

    function updateMedia(variant) {
      if (!mediaRoot || !variant.featured_media_id) return;

      const targetId = String(variant.featured_media_id);
      const slides = mediaRoot.querySelectorAll('[data-media-id]');
      slides.forEach((slide) => {
        const isMatch = slide.dataset.mediaId === targetId;
        if (slide.matches('[data-media-thumb]')) {
          slide.classList.toggle('product-media__thumb--active', isMatch);
          slide.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        } else if (slide.classList.contains('product-media__slide')) {
          slide.hidden = !isMatch;
          slide.classList.toggle('product-media__slide--active', isMatch);
        }
      });

      const primarySlides = mediaRoot.querySelectorAll('.product-media__slide');
      primarySlides.forEach((slide) => {
        const isMatch = slide.dataset.mediaId === targetId;
        slide.hidden = !isMatch;
        slide.classList.toggle('product-media__slide--active', isMatch);
      });

      const thumbs = mediaRoot.querySelectorAll('[data-media-thumb]');
      thumbs.forEach((thumb) => {
        const isMatch = thumb.dataset.mediaId === targetId;
        thumb.classList.toggle('product-media__thumb--active', isMatch);
        thumb.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });
    }

    function updateUrl(variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      updatePrice(variant);
      updateAvailability(variant);
      updateSubmit(variant);
      updateMedia(variant);
      updateUrl(variant.id);
      updateOptionStates();
    }

    function onOptionsChange() {
      const variant = findVariant(getSelectedOptions());
      applyVariant(variant);
    }

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;

        const optionIndex = button.dataset.optionIndex;
        form.querySelectorAll(`[data-option-button][data-option-index="${optionIndex}"]`).forEach((peer) => {
          peer.classList.remove('product-form__option-button--selected');
          peer.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('product-form__option-button--selected');
        button.setAttribute('aria-pressed', 'true');
        onOptionsChange();
      });
    });

    optionSelects.forEach((select) => {
      select.addEventListener('change', onOptionsChange);
    });

    if (decreaseButton && quantityInput) {
      decreaseButton.addEventListener('click', () => {
        const current = Number.parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = String(Math.max(1, current - 1));
      });
    }

    if (increaseButton && quantityInput) {
      increaseButton.addEventListener('click', () => {
        const current = Number.parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = String(current + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        const current = Number.parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = String(Math.max(1, current));
      });
    }

    if (mediaRoot) {
      mediaRoot.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const mediaId = thumb.dataset.mediaId;
          mediaRoot.querySelectorAll('.product-media__slide').forEach((slide) => {
            const isMatch = slide.dataset.mediaId === mediaId;
            slide.hidden = !isMatch;
            slide.classList.toggle('product-media__slide--active', isMatch);
          });

          mediaRoot.querySelectorAll('[data-media-thumb]').forEach((peer) => {
            const isMatch = peer.dataset.mediaId === mediaId;
            peer.classList.toggle('product-media__thumb--active', isMatch);
            peer.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          });
        });
      });

      const scrollRoot = mediaRoot.querySelector('[data-media-scroll]');
      const dots = mediaRoot.querySelectorAll('[data-media-dots] .product-media__dot');
      if (scrollRoot && dots.length) {
        const items = scrollRoot.querySelectorAll('.product-media__scroll-item');
        const syncDots = () => {
          const scrollLeft = scrollRoot.scrollLeft;
          let activeIndex = 0;
          items.forEach((item, index) => {
            if (item.offsetLeft - scrollRoot.offsetLeft <= scrollLeft + item.clientWidth * 0.4) {
              activeIndex = index;
            }
          });
          dots.forEach((dot, index) => {
            dot.classList.toggle('product-media__dot--active', index === activeIndex);
          });
        };
        scrollRoot.addEventListener('scroll', syncDots, { passive: true });
      }
    }

    form.addEventListener('submit', async (event) => {
      if (!submitButton || submitButton.disabled) return;

      if (!window.themeCart?.addItems) return;

      event.preventDefault();

      const variantId = Number.parseInt(variantInput?.value || '', 10);
      const quantity = Number.parseInt(quantityInput?.value || '1', 10) || 1;

      if (!variantId) return;

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = strings.addToCartLoading || strings.addToCart;

      try {
        await window.themeCart.addItems([{ id: variantId, quantity }]);
        window.themeCart.open(submitButton);
      } catch (error) {
        window.themeCart.announce(error.message || strings.error);
      } finally {
        const variant = findVariant(getSelectedOptions());
        if (variant) {
          submitButton.disabled = !variant.available;
          submitButton.removeAttribute('aria-busy');
          submitButton.textContent = variant.available ? strings.addToCart : strings.soldOut;
        }
      }
    });

    updateOptionStates();

    const sticky = section.querySelector('[data-sticky-atc]');
    const stickyTrigger = section.querySelector('[data-sticky-atc-trigger]');
    const buyBoxSubmit = form.querySelector('[data-add-to-cart]');

    if (sticky && stickyTrigger && buyBoxSubmit && window.matchMedia('(max-width: 767px)').matches) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            sticky.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(buyBoxSubmit);

      stickyTrigger.addEventListener('click', () => {
        if (buyBoxSubmit.disabled) return;
        buyBoxSubmit.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
